import gql from 'graphql-tag';
import axios from 'axios';

const UploadVideoMutation = gql`
  mutation uploadEvidenceVideo {
    data: uploadEvidenceVideo {
      success
      video {
        url
        uploadUrl
      }
    }
  }
`;

export const uploadVideo = async (client, params, isEvent = false) => {
  const url = await client.mutate({
    mutation: UploadVideoMutation,
  });

  console.log(params);

  const uploadUrl = url?.data.data.video.uploadUrl;

  // The accessUrl and fileName should be sent to the backend
  const accessUrl = url?.data.data.video.url;
  const file = params.data.video.rawFile;
  const fileName = params.data.video.rawFile.name


  const response = await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return { accessUrl, fileName };
};
